import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import Header from "./components/Header";
// import HeroSection from "./components/HeroSection";
// import FeaturesSection from "./components/FeaturesSection";
import SellerLookup from "./pages/SellerLookup";
import "./App.css";

function App() {
  return (
    <Router>
      {/* <Header /> */}
      <main>
        <Routes>
          <Route
            path="/"
            element={
              <>
                {/* <HeroSection />
                <FeaturesSection /> */}
              </>
            }
          />
          <Route path="/seller-lookup" element={<SellerLookup />} />
        </Routes>
      </main>
    </Router>
  );
}

export default App;